import gql from 'graphql-tag';

import { executeGqlMutation } from 'src/graphql/client';
import { getSingleProp } from 'src/lib/graphql';

import { FRAGMENT_BLOG_POST_BUILDER_BRIEF } from './schema';

const MUTATION = gql`
  mutation UpdateBlogPostBuilderDescription(
    $id: ID!
    $description: String!
    $customerPersonaId: ID
    $tovInput: TovInput
    $urlExtractions: [UrlExtractionInput!]
    $language: String
    $generationCustomModelId: ID
    $freestyleToolAllInstructionsData: JSON
  ) {
    updateBlogPostBuilderDescription(
      id: $id
      description: $description
      customerPersonaId: $customerPersonaId
      tovInput: $tovInput
      urlExtractions: $urlExtractions
      language: $language
      generationCustomModelId: $generationCustomModelId
      freestyleToolAllInstructionsData: $freestyleToolAllInstructionsData
    ) {
      ...BlogPostBuilderBrief
    }
  }
  ${FRAGMENT_BLOG_POST_BUILDER_BRIEF}
`;

export const updateBlogPostBuilderDescription = ({
  id,
  description,
  customerPersona,
  tovInput,
  urlExtractions,
  language,
  generationCustomModelId,
  freestyleToolAllInstructionsData,
}) => {
  const variables = {
    id,
    description,
    customerPersonaId: customerPersona?.id,
    tovInput,
    urlExtractions,
    language,
    generationCustomModelId,
    freestyleToolAllInstructionsData: JSON.stringify(freestyleToolAllInstructionsData),
  };

  return executeGqlMutation({
    mutation: MUTATION,
    variables,
  }).then((response) => getSingleProp(response.data));
};
